<template>
    <div class="banner-area">
        <div class="container p-l-30 p-r-30">
            <div class="row flex-lg-row flex-column-reverse justify-content-between">
                <div class="col-lg-5 col-md-12">
                    <div class="banner-text">
                        <h4>
                            <!-- <span class="d-block">Feeling social?</span> -->
                            Create an Event
                            <!-- &nbsp;<vue-typed-js :strings="welcome_messages.banner_li" :loop="true" :backSpeed="30" :typeSpeed="100">
                                    <strong class="typing"></strong>
                                </vue-typed-js> -->
                        </h4>
                        <p>Organising an In-Person or Online Event has never been easier, cheaper and more flexible. Set-up,
                            promote and sell your event tickets easily</p>
                            
                        <router-link v-if="isAuthenticated" :to="{name:'event-details'}" class="btn btn-gradient btn-lg btn-mw text-uppercase">Add Event</router-link>
                        <router-link v-else to="/authentication/register" class="btn btn-gradient btn-lg btn-mw text-uppercase">Register Now</router-link>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="banner-img text-center">
                        <img class="img-fluid" src="@/assets/images/launch-page/banner-event.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//const { VueTypedJs } = require("vue-typed-js");
import { mapGetters } from "vuex";
export default {
    name: "EventBanner",
    components: {
        //VueTypedJs
    },
    data() {
        return {
            show_banner: false,
            welcome_messages: {
                banner_li: [
                    'Event',
                ],
            },
        };
    },
    computed: {
        ...mapGetters(["currentUser", "isAuthenticated"])
    },
}
</script>